'use client';

import { useEffect } from 'react';

import { usePathname } from 'next/navigation';

import { useAppDispatch } from '@/store';
import { resetState } from '@/store/slices/enrollment';
import { setToken } from '@/store/slices/enrollmentCheckout';

export default function UnloadEnrolleInfo() {
  const dispatch = useAppDispatch();

  const pathname = usePathname();

  useEffect(() => {
    if (
      (!pathname.includes('enrollment') && !pathname.includes('/cart')) ||
      pathname.includes('enrollment/confirmation?token')
    ) {
      console.log('resetting state for enrollment');
      dispatch(resetState());
    }

    if (!pathname.includes('enrollment')) {
      dispatch(setToken(undefined));
    }
  }, [pathname, dispatch]);

  return null;
}
